import React, {FC} from "react";
import {Divider, makeStyles, Typography} from "@material-ui/core";
import {Skeleton} from "@material-ui/lab";
import {format} from "date-fns";
import {FePersonInterface} from "../auth/redux/types";
import {getFullName} from "../utils";
import {StatusIcon} from "./StatusIcon";

interface UserHeadlineProps {
    person?: FePersonInterface;
}

const useStyles = makeStyles((theme) => ({
    userHeadlineContainer: {
        position: 'relative',
        paddingBottom: theme.spacing(4)
    },
    staticCaption: {
        width: theme.spacing(7)
    }
}))

export const PersonHeadline: FC<UserHeadlineProps> = ({person}) => {
    const classes = useStyles();
    return (
        <div className={classes.userHeadlineContainer}>
            <Typography color="primary" variant="h4">{!person ? <Skeleton width={200}/> : getFullName(person, false)}</Typography>
            <div>
                <Typography variant={"caption"} color="textSecondary" style={{display: 'inline-flex'}}>
                    {!person
                        ? (<Skeleton width={160}/>)
                        : (<><Typography variant="inherit" className={classes.staticCaption}>seit:</Typography> {format(new Date(person.createdAt), 'dd.MM.yyyy - HH:mm')}</>)
                    }
                </Typography>
            </div>
            <div>
                <Typography variant={"caption"} color="textSecondary" style={{display: 'inline-flex'}}>
                    {!person
                        ? (<Skeleton width={160}/>)
                        : (<><Typography variant="inherit" className={classes.staticCaption}>geändert:</Typography>{format(new Date(person.updatedAt), 'dd.MM.yyyy - HH:mm')}</>)
                    }
                </Typography>
            </div>
            {typeof person?.active === "boolean" && (
                <div style={{ position: 'absolute', right: 0, top: 24 }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <Typography
                            color="textSecondary"
                            style={{marginRight: 4}}
                        >
                            {person.active ? 'Aktiv' : 'Deaktiviert'}
                        </Typography>
                        <StatusIcon active={person.active}/>
                    </div>
                </div>
            )}
            <Divider style={{ marginTop: 8 }}/>
        </div>
    )
}